export type ReceivedProps = Record<string, any>;

const useBizSheetCategoryStatus = (props: ReceivedProps) => {
  return {
    ...props,
  };
};

export type Props = ReturnType<typeof useBizSheetCategoryStatus>;

export default useBizSheetCategoryStatus;
